import { jsx } from "react/jsx-runtime";
const RadioButtonOn = ({ className = 'tw-text-neutral-light-800', size = 32 })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        children: /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 7c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5Zm0 13c-4.411 0-8-3.59-8-8 0-4.411 3.589-8 8-8s8 3.589 8 8c0 4.41-3.589 8-8 8Zm0-18C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Z",
            fill: "none",
            className: "tw-fill-current"
        })
    });
const RadioButtonOn_RadioButtonOn = RadioButtonOn;
export default RadioButtonOn_RadioButtonOn;
